// source: ManualScoreboard.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.ManualScoreboardMessages.ClockActionType', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ClockDirection', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ClockMessage', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ClockStates', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ControlData', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ControlDataSet', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ControlType', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.EventInfo', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.EventUpdate', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.FullSlide', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.GameInfo', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.GameStates', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.GeneralMessage', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.GraphicLayer', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.GraphicLayers', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ScoreboardHello', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ScoreboardMessageType', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ScoreboardOverride', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ScoreboardProviders', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.ScoreboardUpdateMessage', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.SetSingular', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.SingularConnection', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.TeamColors', null, global);
goog.exportSymbol('proto.ManualScoreboardMessages.TeamNames', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.ClockMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.ClockMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.ClockMessage.displayName = 'proto.ManualScoreboardMessages.ClockMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.TeamNames = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.TeamNames, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.TeamNames.displayName = 'proto.ManualScoreboardMessages.TeamNames';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.TeamColors = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.TeamColors, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.TeamColors.displayName = 'proto.ManualScoreboardMessages.TeamColors';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.ScoreboardUpdateMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.ScoreboardUpdateMessage.displayName = 'proto.ManualScoreboardMessages.ScoreboardUpdateMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.SetSingular = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.SetSingular, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.SetSingular.displayName = 'proto.ManualScoreboardMessages.SetSingular';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.ScoreboardHello = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.ScoreboardHello, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.ScoreboardHello.displayName = 'proto.ManualScoreboardMessages.ScoreboardHello';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.SingularConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.SingularConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.SingularConnection.displayName = 'proto.ManualScoreboardMessages.SingularConnection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.EventUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.EventUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.EventUpdate.displayName = 'proto.ManualScoreboardMessages.EventUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.FullSlide = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.FullSlide, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.FullSlide.displayName = 'proto.ManualScoreboardMessages.FullSlide';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.EventInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.EventInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.EventInfo.displayName = 'proto.ManualScoreboardMessages.EventInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.ScoreboardOverride = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.ScoreboardOverride, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.ScoreboardOverride.displayName = 'proto.ManualScoreboardMessages.ScoreboardOverride';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.GraphicLayer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.GraphicLayer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.GraphicLayer.displayName = 'proto.ManualScoreboardMessages.GraphicLayer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.GraphicLayers = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ManualScoreboardMessages.GraphicLayers.repeatedFields_, null);
};
goog.inherits(proto.ManualScoreboardMessages.GraphicLayers, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.GraphicLayers.displayName = 'proto.ManualScoreboardMessages.GraphicLayers';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.ControlData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.ControlData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.ControlData.displayName = 'proto.ManualScoreboardMessages.ControlData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.ControlDataSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ManualScoreboardMessages.ControlDataSet.repeatedFields_, null);
};
goog.inherits(proto.ManualScoreboardMessages.ControlDataSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.ControlDataSet.displayName = 'proto.ManualScoreboardMessages.ControlDataSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.GameInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.GameInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.GameInfo.displayName = 'proto.ManualScoreboardMessages.GameInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ManualScoreboardMessages.GeneralMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ManualScoreboardMessages.GeneralMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ManualScoreboardMessages.GeneralMessage.displayName = 'proto.ManualScoreboardMessages.GeneralMessage';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.ClockMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.ClockMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ClockMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0),
    direction: jspb.Message.getFieldWithDefault(msg, 2, 0),
    time: jspb.Message.getFieldWithDefault(msg, 3, ""),
    clockstate: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.ClockMessage}
 */
proto.ManualScoreboardMessages.ClockMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.ClockMessage;
  return proto.ManualScoreboardMessages.ClockMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.ClockMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.ClockMessage}
 */
proto.ManualScoreboardMessages.ClockMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ManualScoreboardMessages.ClockActionType} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 2:
      var value = /** @type {!proto.ManualScoreboardMessages.ClockDirection} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTime(value);
      break;
    case 4:
      var value = /** @type {!proto.ManualScoreboardMessages.ClockStates} */ (reader.readEnum());
      msg.setClockstate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.ClockMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.ClockMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ClockMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClockstate();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional ClockActionType action = 1;
 * @return {!proto.ManualScoreboardMessages.ClockActionType}
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.getAction = function() {
  return /** @type {!proto.ManualScoreboardMessages.ClockActionType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ManualScoreboardMessages.ClockActionType} value
 * @return {!proto.ManualScoreboardMessages.ClockMessage} returns this
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ClockDirection direction = 2;
 * @return {!proto.ManualScoreboardMessages.ClockDirection}
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.getDirection = function() {
  return /** @type {!proto.ManualScoreboardMessages.ClockDirection} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ManualScoreboardMessages.ClockDirection} value
 * @return {!proto.ManualScoreboardMessages.ClockMessage} returns this
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.setDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string time = 3;
 * @return {string}
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.getTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.ClockMessage} returns this
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.setTime = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ClockStates clockState = 4;
 * @return {!proto.ManualScoreboardMessages.ClockStates}
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.getClockstate = function() {
  return /** @type {!proto.ManualScoreboardMessages.ClockStates} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.ManualScoreboardMessages.ClockStates} value
 * @return {!proto.ManualScoreboardMessages.ClockMessage} returns this
 */
proto.ManualScoreboardMessages.ClockMessage.prototype.setClockstate = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.TeamNames.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.TeamNames.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.TeamNames} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.TeamNames.toObject = function(includeInstance, msg) {
  var f, obj = {
    hometeamname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    awayteamname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.TeamNames}
 */
proto.ManualScoreboardMessages.TeamNames.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.TeamNames;
  return proto.ManualScoreboardMessages.TeamNames.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.TeamNames} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.TeamNames}
 */
proto.ManualScoreboardMessages.TeamNames.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHometeamname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAwayteamname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.TeamNames.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.TeamNames.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.TeamNames} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.TeamNames.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHometeamname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAwayteamname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string homeTeamName = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.TeamNames.prototype.getHometeamname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.TeamNames} returns this
 */
proto.ManualScoreboardMessages.TeamNames.prototype.setHometeamname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string awayTeamName = 2;
 * @return {string}
 */
proto.ManualScoreboardMessages.TeamNames.prototype.getAwayteamname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.TeamNames} returns this
 */
proto.ManualScoreboardMessages.TeamNames.prototype.setAwayteamname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.TeamColors.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.TeamColors.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.TeamColors} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.TeamColors.toObject = function(includeInstance, msg) {
  var f, obj = {
    hometeamcolor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    awayteamcolor: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.TeamColors}
 */
proto.ManualScoreboardMessages.TeamColors.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.TeamColors;
  return proto.ManualScoreboardMessages.TeamColors.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.TeamColors} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.TeamColors}
 */
proto.ManualScoreboardMessages.TeamColors.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHometeamcolor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAwayteamcolor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.TeamColors.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.TeamColors.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.TeamColors} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.TeamColors.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHometeamcolor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAwayteamcolor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string homeTeamColor = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.TeamColors.prototype.getHometeamcolor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.TeamColors} returns this
 */
proto.ManualScoreboardMessages.TeamColors.prototype.setHometeamcolor = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string awayTeamColor = 2;
 * @return {string}
 */
proto.ManualScoreboardMessages.TeamColors.prototype.getAwayteamcolor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.TeamColors} returns this
 */
proto.ManualScoreboardMessages.TeamColors.prototype.setAwayteamcolor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.ScoreboardUpdateMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    hometeamscore: jspb.Message.getFieldWithDefault(msg, 1, 0),
    awayteamscore: jspb.Message.getFieldWithDefault(msg, 2, 0),
    hometeamscorechange: jspb.Message.getFieldWithDefault(msg, 3, 0),
    awayteamscorechange: jspb.Message.getFieldWithDefault(msg, 4, 0),
    quarter: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.ScoreboardUpdateMessage;
  return proto.ManualScoreboardMessages.ScoreboardUpdateMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHometeamscore(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAwayteamscore(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHometeamscorechange(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAwayteamscorechange(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuarter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.ScoreboardUpdateMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHometeamscore();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAwayteamscore();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getHometeamscorechange();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAwayteamscorechange();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getQuarter();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int64 homeTeamScore = 1;
 * @return {number}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.getHometeamscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage} returns this
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.setHometeamscore = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 awayTeamScore = 2;
 * @return {number}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.getAwayteamscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage} returns this
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.setAwayteamscore = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 homeTeamScoreChange = 3;
 * @return {number}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.getHometeamscorechange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage} returns this
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.setHometeamscorechange = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 awayTeamScoreChange = 4;
 * @return {number}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.getAwayteamscorechange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage} returns this
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.setAwayteamscorechange = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string quarter = 5;
 * @return {string}
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.getQuarter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.ScoreboardUpdateMessage} returns this
 */
proto.ManualScoreboardMessages.ScoreboardUpdateMessage.prototype.setQuarter = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.SetSingular.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.SetSingular.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.SetSingular} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.SetSingular.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, ""),
    polyinit: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.SetSingular}
 */
proto.ManualScoreboardMessages.SetSingular.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.SetSingular;
  return proto.ManualScoreboardMessages.SetSingular.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.SetSingular} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.SetSingular}
 */
proto.ManualScoreboardMessages.SetSingular.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPolyinit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.SetSingular.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.SetSingular.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.SetSingular} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.SetSingular.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPolyinit();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string appId = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.SetSingular.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.SetSingular} returns this
 */
proto.ManualScoreboardMessages.SetSingular.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.ManualScoreboardMessages.SetSingular.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.SetSingular} returns this
 */
proto.ManualScoreboardMessages.SetSingular.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool polyInit = 3;
 * @return {boolean}
 */
proto.ManualScoreboardMessages.SetSingular.prototype.getPolyinit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ManualScoreboardMessages.SetSingular} returns this
 */
proto.ManualScoreboardMessages.SetSingular.prototype.setPolyinit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.ScoreboardHello.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.ScoreboardHello.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.ScoreboardHello} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ScoreboardHello.toObject = function(includeInstance, msg) {
  var f, obj = {
    override: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.ScoreboardHello}
 */
proto.ManualScoreboardMessages.ScoreboardHello.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.ScoreboardHello;
  return proto.ManualScoreboardMessages.ScoreboardHello.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.ScoreboardHello} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.ScoreboardHello}
 */
proto.ManualScoreboardMessages.ScoreboardHello.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverride(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.ScoreboardHello.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.ScoreboardHello.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.ScoreboardHello} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ScoreboardHello.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverride();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool override = 1;
 * @return {boolean}
 */
proto.ManualScoreboardMessages.ScoreboardHello.prototype.getOverride = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ManualScoreboardMessages.ScoreboardHello} returns this
 */
proto.ManualScoreboardMessages.ScoreboardHello.prototype.setOverride = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.SingularConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.SingularConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.SingularConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.SingularConnection.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.SingularConnection}
 */
proto.ManualScoreboardMessages.SingularConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.SingularConnection;
  return proto.ManualScoreboardMessages.SingularConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.SingularConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.SingularConnection}
 */
proto.ManualScoreboardMessages.SingularConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.SingularConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.SingularConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.SingularConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.SingularConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.ManualScoreboardMessages.SingularConnection.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ManualScoreboardMessages.SingularConnection} returns this
 */
proto.ManualScoreboardMessages.SingularConnection.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.EventUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.EventUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.EventUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.EventUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.EventUpdate}
 */
proto.ManualScoreboardMessages.EventUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.EventUpdate;
  return proto.ManualScoreboardMessages.EventUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.EventUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.EventUpdate}
 */
proto.ManualScoreboardMessages.EventUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.EventUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.EventUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.EventUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.EventUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string eventId = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.EventUpdate.prototype.getEventid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.EventUpdate} returns this
 */
proto.ManualScoreboardMessages.EventUpdate.prototype.setEventid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.FullSlide.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.FullSlide.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.FullSlide} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.FullSlide.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, ""),
    visible: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.FullSlide}
 */
proto.ManualScoreboardMessages.FullSlide.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.FullSlide;
  return proto.ManualScoreboardMessages.FullSlide.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.FullSlide} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.FullSlide}
 */
proto.ManualScoreboardMessages.FullSlide.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.FullSlide.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.FullSlide.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.FullSlide} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.FullSlide.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.FullSlide.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.FullSlide} returns this
 */
proto.ManualScoreboardMessages.FullSlide.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool visible = 2;
 * @return {boolean}
 */
proto.ManualScoreboardMessages.FullSlide.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ManualScoreboardMessages.FullSlide} returns this
 */
proto.ManualScoreboardMessages.FullSlide.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.EventInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.EventInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.EventInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.EventInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    sporttype: jspb.Message.getFieldWithDefault(msg, 1, ""),
    periodlength: jspb.Message.getFieldWithDefault(msg, 2, 0),
    extratime: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.EventInfo}
 */
proto.ManualScoreboardMessages.EventInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.EventInfo;
  return proto.ManualScoreboardMessages.EventInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.EventInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.EventInfo}
 */
proto.ManualScoreboardMessages.EventInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSporttype(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPeriodlength(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtratime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.EventInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.EventInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.EventInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.EventInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSporttype();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPeriodlength();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getExtratime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string sportType = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.EventInfo.prototype.getSporttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.EventInfo} returns this
 */
proto.ManualScoreboardMessages.EventInfo.prototype.setSporttype = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 periodLength = 2;
 * @return {number}
 */
proto.ManualScoreboardMessages.EventInfo.prototype.getPeriodlength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ManualScoreboardMessages.EventInfo} returns this
 */
proto.ManualScoreboardMessages.EventInfo.prototype.setPeriodlength = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 extraTime = 3;
 * @return {number}
 */
proto.ManualScoreboardMessages.EventInfo.prototype.getExtratime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ManualScoreboardMessages.EventInfo} returns this
 */
proto.ManualScoreboardMessages.EventInfo.prototype.setExtratime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.ScoreboardOverride.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.ScoreboardOverride.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.ScoreboardOverride} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ScoreboardOverride.toObject = function(includeInstance, msg) {
  var f, obj = {
    scoreboardprovider: jspb.Message.getFieldWithDefault(msg, 1, 0),
    forceoverride: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.ScoreboardOverride}
 */
proto.ManualScoreboardMessages.ScoreboardOverride.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.ScoreboardOverride;
  return proto.ManualScoreboardMessages.ScoreboardOverride.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.ScoreboardOverride} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.ScoreboardOverride}
 */
proto.ManualScoreboardMessages.ScoreboardOverride.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ManualScoreboardMessages.ScoreboardProviders} */ (reader.readEnum());
      msg.setScoreboardprovider(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForceoverride(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.ScoreboardOverride.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.ScoreboardOverride.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.ScoreboardOverride} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ScoreboardOverride.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScoreboardprovider();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getForceoverride();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional ScoreboardProviders scoreboardProvider = 1;
 * @return {!proto.ManualScoreboardMessages.ScoreboardProviders}
 */
proto.ManualScoreboardMessages.ScoreboardOverride.prototype.getScoreboardprovider = function() {
  return /** @type {!proto.ManualScoreboardMessages.ScoreboardProviders} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ManualScoreboardMessages.ScoreboardProviders} value
 * @return {!proto.ManualScoreboardMessages.ScoreboardOverride} returns this
 */
proto.ManualScoreboardMessages.ScoreboardOverride.prototype.setScoreboardprovider = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool forceOverride = 2;
 * @return {boolean}
 */
proto.ManualScoreboardMessages.ScoreboardOverride.prototype.getForceoverride = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ManualScoreboardMessages.ScoreboardOverride} returns this
 */
proto.ManualScoreboardMessages.ScoreboardOverride.prototype.setForceoverride = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.GraphicLayer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.GraphicLayer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.GraphicLayer.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, ""),
    state: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    updateui: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    skiprules: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.GraphicLayer}
 */
proto.ManualScoreboardMessages.GraphicLayer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.GraphicLayer;
  return proto.ManualScoreboardMessages.GraphicLayer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.GraphicLayer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.GraphicLayer}
 */
proto.ManualScoreboardMessages.GraphicLayer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setState(value);
      break;
    case 5:
      var value = /** @type {!proto.ManualScoreboardMessages.ControlType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUpdateui(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkiprules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.GraphicLayer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.GraphicLayer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.GraphicLayer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getState();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getUpdateui();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getSkiprules();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayer} returns this
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayer} returns this
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string value = 3;
 * @return {string}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayer} returns this
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool state = 4;
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.getState = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayer} returns this
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.setState = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional ControlType type = 5;
 * @return {!proto.ManualScoreboardMessages.ControlType}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.getType = function() {
  return /** @type {!proto.ManualScoreboardMessages.ControlType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.ManualScoreboardMessages.ControlType} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayer} returns this
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool updateUI = 6;
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.getUpdateui = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayer} returns this
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.setUpdateui = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool skipRules = 7;
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.getSkiprules = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayer} returns this
 */
proto.ManualScoreboardMessages.GraphicLayer.prototype.setSkiprules = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ManualScoreboardMessages.GraphicLayers.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.GraphicLayers.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.GraphicLayers.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.GraphicLayers} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.GraphicLayers.toObject = function(includeInstance, msg) {
  var f, obj = {
    layersList: jspb.Message.toObjectList(msg.getLayersList(),
    proto.ManualScoreboardMessages.GraphicLayer.toObject, includeInstance),
    ts: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.GraphicLayers}
 */
proto.ManualScoreboardMessages.GraphicLayers.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.GraphicLayers;
  return proto.ManualScoreboardMessages.GraphicLayers.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.GraphicLayers} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.GraphicLayers}
 */
proto.ManualScoreboardMessages.GraphicLayers.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ManualScoreboardMessages.GraphicLayer;
      reader.readMessage(value,proto.ManualScoreboardMessages.GraphicLayer.deserializeBinaryFromReader);
      msg.addLayers(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.GraphicLayers.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.GraphicLayers.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.GraphicLayers} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.GraphicLayers.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLayersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ManualScoreboardMessages.GraphicLayer.serializeBinaryToWriter
    );
  }
  f = message.getTs();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated GraphicLayer layers = 1;
 * @return {!Array<!proto.ManualScoreboardMessages.GraphicLayer>}
 */
proto.ManualScoreboardMessages.GraphicLayers.prototype.getLayersList = function() {
  return /** @type{!Array<!proto.ManualScoreboardMessages.GraphicLayer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ManualScoreboardMessages.GraphicLayer, 1));
};


/**
 * @param {!Array<!proto.ManualScoreboardMessages.GraphicLayer>} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayers} returns this
*/
proto.ManualScoreboardMessages.GraphicLayers.prototype.setLayersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ManualScoreboardMessages.GraphicLayer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ManualScoreboardMessages.GraphicLayer}
 */
proto.ManualScoreboardMessages.GraphicLayers.prototype.addLayers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ManualScoreboardMessages.GraphicLayer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ManualScoreboardMessages.GraphicLayers} returns this
 */
proto.ManualScoreboardMessages.GraphicLayers.prototype.clearLayersList = function() {
  return this.setLayersList([]);
};


/**
 * optional int64 ts = 2;
 * @return {number}
 */
proto.ManualScoreboardMessages.GraphicLayers.prototype.getTs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ManualScoreboardMessages.GraphicLayers} returns this
 */
proto.ManualScoreboardMessages.GraphicLayers.prototype.setTs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.ControlData.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.ControlData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.ControlData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ControlData.toObject = function(includeInstance, msg) {
  var f, obj = {
    controlname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    controlvalue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.ControlData}
 */
proto.ManualScoreboardMessages.ControlData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.ControlData;
  return proto.ManualScoreboardMessages.ControlData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.ControlData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.ControlData}
 */
proto.ManualScoreboardMessages.ControlData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlvalue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.ControlData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.ControlData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.ControlData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ControlData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getControlvalue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ControlName = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.ControlData.prototype.getControlname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.ControlData} returns this
 */
proto.ManualScoreboardMessages.ControlData.prototype.setControlname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ControlValue = 2;
 * @return {string}
 */
proto.ManualScoreboardMessages.ControlData.prototype.getControlvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.ControlData} returns this
 */
proto.ManualScoreboardMessages.ControlData.prototype.setControlvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ManualScoreboardMessages.ControlDataSet.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.ControlDataSet.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.ControlDataSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.ControlDataSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ControlDataSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.ManualScoreboardMessages.ControlData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.ControlDataSet}
 */
proto.ManualScoreboardMessages.ControlDataSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.ControlDataSet;
  return proto.ManualScoreboardMessages.ControlDataSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.ControlDataSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.ControlDataSet}
 */
proto.ManualScoreboardMessages.ControlDataSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ManualScoreboardMessages.ControlData;
      reader.readMessage(value,proto.ManualScoreboardMessages.ControlData.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.ControlDataSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.ControlDataSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.ControlDataSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.ControlDataSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ManualScoreboardMessages.ControlData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ControlData data = 1;
 * @return {!Array<!proto.ManualScoreboardMessages.ControlData>}
 */
proto.ManualScoreboardMessages.ControlDataSet.prototype.getDataList = function() {
  return /** @type{!Array<!proto.ManualScoreboardMessages.ControlData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ManualScoreboardMessages.ControlData, 1));
};


/**
 * @param {!Array<!proto.ManualScoreboardMessages.ControlData>} value
 * @return {!proto.ManualScoreboardMessages.ControlDataSet} returns this
*/
proto.ManualScoreboardMessages.ControlDataSet.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ManualScoreboardMessages.ControlData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ManualScoreboardMessages.ControlData}
 */
proto.ManualScoreboardMessages.ControlDataSet.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ManualScoreboardMessages.ControlData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ManualScoreboardMessages.ControlDataSet} returns this
 */
proto.ManualScoreboardMessages.ControlDataSet.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.GameInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.GameInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.GameInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    team1: jspb.Message.getFieldWithDefault(msg, 3, ""),
    team2: jspb.Message.getFieldWithDefault(msg, 4, ""),
    team1id: jspb.Message.getFieldWithDefault(msg, 5, ""),
    team2id: jspb.Message.getFieldWithDefault(msg, 6, ""),
    team1color: jspb.Message.getFieldWithDefault(msg, 7, ""),
    team2color: jspb.Message.getFieldWithDefault(msg, 8, ""),
    team1short: jspb.Message.getFieldWithDefault(msg, 9, ""),
    team2short: jspb.Message.getFieldWithDefault(msg, 10, ""),
    team1logo: jspb.Message.getFieldWithDefault(msg, 11, ""),
    team2logo: jspb.Message.getFieldWithDefault(msg, 12, ""),
    autoproduction: jspb.Message.getFieldWithDefault(msg, 13, ""),
    cameraautoproduction: jspb.Message.getFieldWithDefault(msg, 14, ""),
    score1: jspb.Message.getFieldWithDefault(msg, 15, ""),
    score2: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.GameInfo}
 */
proto.ManualScoreboardMessages.GameInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.GameInfo;
  return proto.ManualScoreboardMessages.GameInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.GameInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.GameInfo}
 */
proto.ManualScoreboardMessages.GameInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam1(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam2(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam1id(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam2id(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam1color(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam2color(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam1short(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam2short(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam1logo(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeam2logo(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAutoproduction(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCameraautoproduction(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setScore1(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setScore2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.GameInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.GameInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.GameInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTeam1();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTeam2();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTeam1id();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTeam2id();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTeam1color();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTeam2color();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTeam1short();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTeam2short();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTeam1logo();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTeam2logo();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAutoproduction();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCameraautoproduction();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getScore1();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getScore2();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string team1 = 3;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam1 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string team2 = 4;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam2 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string team1Id = 5;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam1id = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam1id = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string team2Id = 6;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam2id = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam2id = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string team1Color = 7;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam1color = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam1color = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string team2Color = 8;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam2color = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam2color = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string team1Short = 9;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam1short = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam1short = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string team2Short = 10;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam2short = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam2short = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string team1Logo = 11;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam1logo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam1logo = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string team2Logo = 12;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getTeam2logo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setTeam2logo = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string autoProduction = 13;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getAutoproduction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setAutoproduction = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string cameraAutoProduction = 14;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getCameraautoproduction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setCameraautoproduction = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string score1 = 15;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getScore1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setScore1 = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string score2 = 16;
 * @return {string}
 */
proto.ManualScoreboardMessages.GameInfo.prototype.getScore2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GameInfo} returns this
 */
proto.ManualScoreboardMessages.GameInfo.prototype.setScore2 = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.ManualScoreboardMessages.GeneralMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ManualScoreboardMessages.GeneralMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.GeneralMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagetype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hellomessage: (f = msg.getHellomessage()) && proto.ManualScoreboardMessages.ScoreboardHello.toObject(includeInstance, f),
    clockmessage: (f = msg.getClockmessage()) && proto.ManualScoreboardMessages.ClockMessage.toObject(includeInstance, f),
    updatemessage: (f = msg.getUpdatemessage()) && proto.ManualScoreboardMessages.ScoreboardUpdateMessage.toObject(includeInstance, f),
    singularmessage: (f = msg.getSingularmessage()) && proto.ManualScoreboardMessages.SetSingular.toObject(includeInstance, f),
    teamnamesmessage: (f = msg.getTeamnamesmessage()) && proto.ManualScoreboardMessages.TeamNames.toObject(includeInstance, f),
    statemessage: jspb.Message.getFieldWithDefault(msg, 7, 0),
    timestamp: jspb.Message.getFieldWithDefault(msg, 8, 0),
    singularconnectionmessage: (f = msg.getSingularconnectionmessage()) && proto.ManualScoreboardMessages.SingularConnection.toObject(includeInstance, f),
    teamcolorsmessage: (f = msg.getTeamcolorsmessage()) && proto.ManualScoreboardMessages.TeamColors.toObject(includeInstance, f),
    eventupdatemessage: (f = msg.getEventupdatemessage()) && proto.ManualScoreboardMessages.EventUpdate.toObject(includeInstance, f),
    fullslidemessage: (f = msg.getFullslidemessage()) && proto.ManualScoreboardMessages.FullSlide.toObject(includeInstance, f),
    eventinfomessage: (f = msg.getEventinfomessage()) && proto.ManualScoreboardMessages.EventInfo.toObject(includeInstance, f),
    graphiclayersmessage: (f = msg.getGraphiclayersmessage()) && proto.ManualScoreboardMessages.GraphicLayers.toObject(includeInstance, f),
    graphicgenericmessage: jspb.Message.getFieldWithDefault(msg, 15, ""),
    gameinfomessage: (f = msg.getGameinfomessage()) && proto.ManualScoreboardMessages.GameInfo.toObject(includeInstance, f),
    controldatamessage: (f = msg.getControldatamessage()) && proto.ManualScoreboardMessages.ControlDataSet.toObject(includeInstance, f),
    scoreboardoverridemessage: (f = msg.getScoreboardoverridemessage()) && proto.ManualScoreboardMessages.ScoreboardOverride.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage}
 */
proto.ManualScoreboardMessages.GeneralMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ManualScoreboardMessages.GeneralMessage;
  return proto.ManualScoreboardMessages.GeneralMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ManualScoreboardMessages.GeneralMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage}
 */
proto.ManualScoreboardMessages.GeneralMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ManualScoreboardMessages.ScoreboardMessageType} */ (reader.readEnum());
      msg.setMessagetype(value);
      break;
    case 2:
      var value = new proto.ManualScoreboardMessages.ScoreboardHello;
      reader.readMessage(value,proto.ManualScoreboardMessages.ScoreboardHello.deserializeBinaryFromReader);
      msg.setHellomessage(value);
      break;
    case 3:
      var value = new proto.ManualScoreboardMessages.ClockMessage;
      reader.readMessage(value,proto.ManualScoreboardMessages.ClockMessage.deserializeBinaryFromReader);
      msg.setClockmessage(value);
      break;
    case 4:
      var value = new proto.ManualScoreboardMessages.ScoreboardUpdateMessage;
      reader.readMessage(value,proto.ManualScoreboardMessages.ScoreboardUpdateMessage.deserializeBinaryFromReader);
      msg.setUpdatemessage(value);
      break;
    case 5:
      var value = new proto.ManualScoreboardMessages.SetSingular;
      reader.readMessage(value,proto.ManualScoreboardMessages.SetSingular.deserializeBinaryFromReader);
      msg.setSingularmessage(value);
      break;
    case 6:
      var value = new proto.ManualScoreboardMessages.TeamNames;
      reader.readMessage(value,proto.ManualScoreboardMessages.TeamNames.deserializeBinaryFromReader);
      msg.setTeamnamesmessage(value);
      break;
    case 7:
      var value = /** @type {!proto.ManualScoreboardMessages.GameStates} */ (reader.readEnum());
      msg.setStatemessage(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 9:
      var value = new proto.ManualScoreboardMessages.SingularConnection;
      reader.readMessage(value,proto.ManualScoreboardMessages.SingularConnection.deserializeBinaryFromReader);
      msg.setSingularconnectionmessage(value);
      break;
    case 10:
      var value = new proto.ManualScoreboardMessages.TeamColors;
      reader.readMessage(value,proto.ManualScoreboardMessages.TeamColors.deserializeBinaryFromReader);
      msg.setTeamcolorsmessage(value);
      break;
    case 11:
      var value = new proto.ManualScoreboardMessages.EventUpdate;
      reader.readMessage(value,proto.ManualScoreboardMessages.EventUpdate.deserializeBinaryFromReader);
      msg.setEventupdatemessage(value);
      break;
    case 12:
      var value = new proto.ManualScoreboardMessages.FullSlide;
      reader.readMessage(value,proto.ManualScoreboardMessages.FullSlide.deserializeBinaryFromReader);
      msg.setFullslidemessage(value);
      break;
    case 13:
      var value = new proto.ManualScoreboardMessages.EventInfo;
      reader.readMessage(value,proto.ManualScoreboardMessages.EventInfo.deserializeBinaryFromReader);
      msg.setEventinfomessage(value);
      break;
    case 14:
      var value = new proto.ManualScoreboardMessages.GraphicLayers;
      reader.readMessage(value,proto.ManualScoreboardMessages.GraphicLayers.deserializeBinaryFromReader);
      msg.setGraphiclayersmessage(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraphicgenericmessage(value);
      break;
    case 16:
      var value = new proto.ManualScoreboardMessages.GameInfo;
      reader.readMessage(value,proto.ManualScoreboardMessages.GameInfo.deserializeBinaryFromReader);
      msg.setGameinfomessage(value);
      break;
    case 17:
      var value = new proto.ManualScoreboardMessages.ControlDataSet;
      reader.readMessage(value,proto.ManualScoreboardMessages.ControlDataSet.deserializeBinaryFromReader);
      msg.setControldatamessage(value);
      break;
    case 18:
      var value = new proto.ManualScoreboardMessages.ScoreboardOverride;
      reader.readMessage(value,proto.ManualScoreboardMessages.ScoreboardOverride.deserializeBinaryFromReader);
      msg.setScoreboardoverridemessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ManualScoreboardMessages.GeneralMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ManualScoreboardMessages.GeneralMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ManualScoreboardMessages.GeneralMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagetype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getHellomessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ManualScoreboardMessages.ScoreboardHello.serializeBinaryToWriter
    );
  }
  f = message.getClockmessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ManualScoreboardMessages.ClockMessage.serializeBinaryToWriter
    );
  }
  f = message.getUpdatemessage();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ManualScoreboardMessages.ScoreboardUpdateMessage.serializeBinaryToWriter
    );
  }
  f = message.getSingularmessage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ManualScoreboardMessages.SetSingular.serializeBinaryToWriter
    );
  }
  f = message.getTeamnamesmessage();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ManualScoreboardMessages.TeamNames.serializeBinaryToWriter
    );
  }
  f = message.getStatemessage();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getSingularconnectionmessage();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ManualScoreboardMessages.SingularConnection.serializeBinaryToWriter
    );
  }
  f = message.getTeamcolorsmessage();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ManualScoreboardMessages.TeamColors.serializeBinaryToWriter
    );
  }
  f = message.getEventupdatemessage();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ManualScoreboardMessages.EventUpdate.serializeBinaryToWriter
    );
  }
  f = message.getFullslidemessage();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ManualScoreboardMessages.FullSlide.serializeBinaryToWriter
    );
  }
  f = message.getEventinfomessage();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ManualScoreboardMessages.EventInfo.serializeBinaryToWriter
    );
  }
  f = message.getGraphiclayersmessage();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.ManualScoreboardMessages.GraphicLayers.serializeBinaryToWriter
    );
  }
  f = message.getGraphicgenericmessage();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getGameinfomessage();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.ManualScoreboardMessages.GameInfo.serializeBinaryToWriter
    );
  }
  f = message.getControldatamessage();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.ManualScoreboardMessages.ControlDataSet.serializeBinaryToWriter
    );
  }
  f = message.getScoreboardoverridemessage();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.ManualScoreboardMessages.ScoreboardOverride.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScoreboardMessageType messageType = 1;
 * @return {!proto.ManualScoreboardMessages.ScoreboardMessageType}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getMessagetype = function() {
  return /** @type {!proto.ManualScoreboardMessages.ScoreboardMessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ManualScoreboardMessages.ScoreboardMessageType} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.setMessagetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ScoreboardHello helloMessage = 2;
 * @return {?proto.ManualScoreboardMessages.ScoreboardHello}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getHellomessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.ScoreboardHello} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.ScoreboardHello, 2));
};


/**
 * @param {?proto.ManualScoreboardMessages.ScoreboardHello|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setHellomessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearHellomessage = function() {
  return this.setHellomessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasHellomessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ClockMessage clockMessage = 3;
 * @return {?proto.ManualScoreboardMessages.ClockMessage}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getClockmessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.ClockMessage} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.ClockMessage, 3));
};


/**
 * @param {?proto.ManualScoreboardMessages.ClockMessage|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setClockmessage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearClockmessage = function() {
  return this.setClockmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasClockmessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ScoreboardUpdateMessage updateMessage = 4;
 * @return {?proto.ManualScoreboardMessages.ScoreboardUpdateMessage}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getUpdatemessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.ScoreboardUpdateMessage} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.ScoreboardUpdateMessage, 4));
};


/**
 * @param {?proto.ManualScoreboardMessages.ScoreboardUpdateMessage|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setUpdatemessage = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearUpdatemessage = function() {
  return this.setUpdatemessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasUpdatemessage = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SetSingular singularMessage = 5;
 * @return {?proto.ManualScoreboardMessages.SetSingular}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getSingularmessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.SetSingular} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.SetSingular, 5));
};


/**
 * @param {?proto.ManualScoreboardMessages.SetSingular|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setSingularmessage = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearSingularmessage = function() {
  return this.setSingularmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasSingularmessage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TeamNames teamNamesMessage = 6;
 * @return {?proto.ManualScoreboardMessages.TeamNames}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getTeamnamesmessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.TeamNames} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.TeamNames, 6));
};


/**
 * @param {?proto.ManualScoreboardMessages.TeamNames|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setTeamnamesmessage = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearTeamnamesmessage = function() {
  return this.setTeamnamesmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasTeamnamesmessage = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional GameStates stateMessage = 7;
 * @return {!proto.ManualScoreboardMessages.GameStates}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getStatemessage = function() {
  return /** @type {!proto.ManualScoreboardMessages.GameStates} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.ManualScoreboardMessages.GameStates} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.setStatemessage = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int64 timestamp = 8;
 * @return {number}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional SingularConnection singularConnectionMessage = 9;
 * @return {?proto.ManualScoreboardMessages.SingularConnection}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getSingularconnectionmessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.SingularConnection} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.SingularConnection, 9));
};


/**
 * @param {?proto.ManualScoreboardMessages.SingularConnection|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setSingularconnectionmessage = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearSingularconnectionmessage = function() {
  return this.setSingularconnectionmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasSingularconnectionmessage = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional TeamColors teamColorsMessage = 10;
 * @return {?proto.ManualScoreboardMessages.TeamColors}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getTeamcolorsmessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.TeamColors} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.TeamColors, 10));
};


/**
 * @param {?proto.ManualScoreboardMessages.TeamColors|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setTeamcolorsmessage = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearTeamcolorsmessage = function() {
  return this.setTeamcolorsmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasTeamcolorsmessage = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional EventUpdate eventUpdateMessage = 11;
 * @return {?proto.ManualScoreboardMessages.EventUpdate}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getEventupdatemessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.EventUpdate} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.EventUpdate, 11));
};


/**
 * @param {?proto.ManualScoreboardMessages.EventUpdate|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setEventupdatemessage = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearEventupdatemessage = function() {
  return this.setEventupdatemessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasEventupdatemessage = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional FullSlide fullSlideMessage = 12;
 * @return {?proto.ManualScoreboardMessages.FullSlide}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getFullslidemessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.FullSlide} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.FullSlide, 12));
};


/**
 * @param {?proto.ManualScoreboardMessages.FullSlide|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setFullslidemessage = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearFullslidemessage = function() {
  return this.setFullslidemessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasFullslidemessage = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional EventInfo eventInfoMessage = 13;
 * @return {?proto.ManualScoreboardMessages.EventInfo}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getEventinfomessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.EventInfo} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.EventInfo, 13));
};


/**
 * @param {?proto.ManualScoreboardMessages.EventInfo|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setEventinfomessage = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearEventinfomessage = function() {
  return this.setEventinfomessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasEventinfomessage = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional GraphicLayers graphicLayersMessage = 14;
 * @return {?proto.ManualScoreboardMessages.GraphicLayers}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getGraphiclayersmessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.GraphicLayers} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.GraphicLayers, 14));
};


/**
 * @param {?proto.ManualScoreboardMessages.GraphicLayers|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setGraphiclayersmessage = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearGraphiclayersmessage = function() {
  return this.setGraphiclayersmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasGraphiclayersmessage = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string graphicGenericMessage = 15;
 * @return {string}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getGraphicgenericmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.setGraphicgenericmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional GameInfo gameInfoMessage = 16;
 * @return {?proto.ManualScoreboardMessages.GameInfo}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getGameinfomessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.GameInfo} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.GameInfo, 16));
};


/**
 * @param {?proto.ManualScoreboardMessages.GameInfo|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setGameinfomessage = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearGameinfomessage = function() {
  return this.setGameinfomessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasGameinfomessage = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional ControlDataSet controlDataMessage = 17;
 * @return {?proto.ManualScoreboardMessages.ControlDataSet}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getControldatamessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.ControlDataSet} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.ControlDataSet, 17));
};


/**
 * @param {?proto.ManualScoreboardMessages.ControlDataSet|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setControldatamessage = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearControldatamessage = function() {
  return this.setControldatamessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasControldatamessage = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional ScoreboardOverride scoreboardOverrideMessage = 18;
 * @return {?proto.ManualScoreboardMessages.ScoreboardOverride}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.getScoreboardoverridemessage = function() {
  return /** @type{?proto.ManualScoreboardMessages.ScoreboardOverride} */ (
    jspb.Message.getWrapperField(this, proto.ManualScoreboardMessages.ScoreboardOverride, 18));
};


/**
 * @param {?proto.ManualScoreboardMessages.ScoreboardOverride|undefined} value
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
*/
proto.ManualScoreboardMessages.GeneralMessage.prototype.setScoreboardoverridemessage = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ManualScoreboardMessages.GeneralMessage} returns this
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.clearScoreboardoverridemessage = function() {
  return this.setScoreboardoverridemessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ManualScoreboardMessages.GeneralMessage.prototype.hasScoreboardoverridemessage = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * @enum {number}
 */
proto.ManualScoreboardMessages.ClockActionType = {
  CLOCK_ACTION_START: 0,
  CLOCK_ACTION_STOP: 1,
  CLOCK_ACTION_SET: 2,
  CLOCK_ACTION_INFO: 3
};

/**
 * @enum {number}
 */
proto.ManualScoreboardMessages.ClockDirection = {
  CLOCK_DIRECTION_UP: 0,
  CLOCK_DIRECTION_DOWN: 1
};

/**
 * @enum {number}
 */
proto.ManualScoreboardMessages.GameStates = {
  GAME_STATE_STARTED: 0,
  GAME_STATE_STOPPED: 1
};

/**
 * @enum {number}
 */
proto.ManualScoreboardMessages.ClockStates = {
  CLOCK_STATE_STARTED: 0,
  CLOCK_STATE_STOPPED: 1
};

/**
 * @enum {number}
 */
proto.ManualScoreboardMessages.ScoreboardProviders = {
  WEB: 0,
  OCR: 1,
  SPORTZCAST: 2
};

/**
 * @enum {number}
 */
proto.ManualScoreboardMessages.ControlType = {
  UNKNOWN: 0,
  BOOL: 1,
  INT: 2,
  STRING: 3,
  PICTURE: 4
};

/**
 * @enum {number}
 */
proto.ManualScoreboardMessages.ScoreboardMessageType = {
  SB_MESSAGE_TYPE_HELLO: 0,
  SB_MESSAGE_TYPE_CLOCK: 1,
  SB_MESSAGE_TYPE_UPDATE: 2,
  SB_MESSAGE_TYPE_SINGULAR: 3,
  SB_MESSAGE_TYPE_TEAMNAMES: 4,
  SB_MESSAGE_TYPE_CONNECTION: 5,
  SB_MESSAGE_TYPE_TEAMCOLORS: 6,
  SB_MESSAGE_TYPE_START_EVENT: 7,
  SB_MESSAGE_TYPE_STOP_EVENT: 8,
  SB_MESSAGE_TYPE_FULL_SLIDE: 9,
  SB_MESSAGE_TYPE_EVENT_INFO: 10,
  SB_MESSAGE_TYPE_GRAPHICS_LAYERS: 11,
  SB_MESSAGE_TYPE_GRAPHICS_GENERIC: 12,
  SB_MESSAGE_TYPE_GAME_INFO: 13,
  SB_MESSAGE_TYPE_OVERRIDE_SCOREBOARD: 14,
  SB_MESSAGE_TYPE_CONTROL_DATA: 15
};

goog.object.extend(exports, proto.ManualScoreboardMessages);



// WEBPACK FOOTER //
// ./src/proto/ManualScoreboard_pb.js